import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import usePage from "./usePage";

export default function () {
  const {pageFields, handleSubmit, reset, setData, setErrors} = usePage();

  const {id} = useParams()
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(  `pages/${id}/edit`).then(res => {
      if(res.data.status === 'success'){
        setData(res.data)
        reset(res.data.page);
      }
    });
  }, []);

  const edit = data => {
    axios.put(`pages/${id}`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Page has been updated successfully!', {
            icon: "success",
          });
          navigate("/pages");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit Page">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>
        {pageFields}

        <SubmitButton
          title="Update"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}